<template>
  <b-row class="steps-container text-center">
    <div class="cursor-pointer step-container" @click="changeStatus('plans')">
      <Step :status="planStatus">{{ $t('purchase.header.steps.choosePlan') }}</Step>
    </div>
    <Divider :status="planConnector" />
    <div class="step-container">
      <Step :status="accountStatus">{{ $t('purchase.header.steps.createAccount') }}</Step>
    </div>
    <Divider :status="accountConnector" />
    <div class="step-container">
      <Step :status="paymentStatus">{{ $t('purchase.header.steps.payment') }}</Step>
    </div>
    <Divider :status="paymentConnector" />
    <div class="step-container">
      <Step :status="downloadStatus">{{ $t('purchase.header.steps.download') }}</Step>
    </div>
  </b-row>
</template>

<script>
import Step from '@/components/PurchaseFlow/Header/Steps/IndividualStep';
import Divider from '@/components/PurchaseFlow/Header/Steps/Divider';
import { mapState } from 'vuex';
export default {
  components: {
    Step,
    Divider
  },
  props: {
    status: {
      type: String,
      required: false,
      default: 'plans'
    }
  },
  computed: {
    ...mapState('vectors', ['actualVector']),
    ...mapState('plans', ['firstStepAction']),
    planStatus() {
      if (this.status == 'plans') {
        return 'actual';
      } else {
        return 'done';
      }
    },
    accountStatus() {
      if (this.status == 'account') {
        return 'actual';
      } else if (this.status == 'plans') {
        return 'disabled';
      } else {
        return 'done';
      }
    },
    paymentStatus() {
      if (this.status == 'payment') {
        return 'actual';
      } else if (['plans', 'account'].includes(this.status)) {
        return 'disabled';
      } else {
        return 'done';
      }
    },
    downloadStatus() {
      return this.status == 'download' ? 'done' : 'disabled';
    },
    planConnector() {
      return this.status == 'plan' ? 'next' : '';
    },
    accountConnector() {
      return this.status == 'account' ? 'next' : '';
    },
    paymentConnector() {
      return this.status == 'payment' ? 'next' : '';
    }
  },
  methods: {
    changeStatus(status) {
      if (this.firstStepAction == 'closeModal') {
        this.$bvModal.hide('purchase-modal');
      } else if (!this.actualVector) {
        this.$router.back();
      } else {
        this.$store.commit('vectors/SET_PURCHASE_FLOW_STATUS', status);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.steps-container {
  @include sm {
    justify-content: center;
  }
}
.step-container {
  width: 100px;
  margin-right: 10px;
}
</style>
